import AssignmentLabelSelectorContainer from './containers/AssignmentLabelSelectorContainer'

export default AssignmentLabelSelectorContainer
